<div edsGrid>
  <div edsRow>
    <div edsCol>
      <eds-proximal placement="DividendsProximalTop"></eds-proximal>
      <eds-section-header
        [title]="
          'products.distribution-distributions-per-share' | translate: fundId
        "
        [level]="3"
        [size]="'h3'"
        [asOfLabel]="'products.as-of' | translate"
        caveatPlacement="Distribution:DividendsPriceDistribution"
        edsSpacing="md"
      ></eds-section-header>
    </div>
  </div>
  <div edsRow *ngIf="!isSiteIntl && capGainRecords && displayCapGainRecords">
    <div edsCol>
      <eds-section-header
        [title]="
          'products.distribution-capital-gains-estimates-tile' | translate
        "
        [level]="6"
        [size]="'h6'"
        edsSpacing="md"
      ></eds-section-header>
      <eds-proximal placement="USCapitalGainEstimates"></eds-proximal>
    </div>
  </div>
  <div edsRow *ngIf="!isSiteIntl && capGainRecords">
    <div edsCol>
      <eds-dynamic-table
        *ngIf="(isHandheld$ | async) === false"
        [colDefs]="colDefs"
        [rowData]="capGainRecords"
        tableTheme="primary"
        [hasBorders]="true"
        [showPagination]="false"
        [rowTemplate]="capGainsRow"
      ></eds-dynamic-table>
      <div *ngIf="isHandheld$ | async">
        <ft-distribution-capital-gains-cards
          *ngFor="let item of capGainRecords"
          [cardData]="item"
        >
        </ft-distribution-capital-gains-cards>
      </div>
    </div>
  </div>
  <div edsRow *ngIf="!isSiteIntl">
    <div edsCol>
      <h6 edsSpacing="md">
        {{
          "products.distribution-distributions-table-title" | translate: fundId
        }}
      </h6>
    </div>
  </div>
  <div *ngIf="!isSiteIntl && latestDistributions.length" edsSpacing="md">
    <span>
      {{ "products.distribution-estimate-tooltip-label" | translate: fundId }}
    </span>
    <button
      class="print-hidden"
      edsTooltip
      [analyticsName]="
        'products.distribution-estimate-tooltip-label' | translate: fundId
      "
      [tooltipContent]="
        'products.distribution-estimate-tooltip-content' | translate: fundId
      "
      [tooltipAriaLabel]="
        'products.distribution-estimate-tooltip-label' | translate
      "
      [tooltipButton]="true"
    >
      <eds-icon type="info" size="small"></eds-icon>
    </button>
  </div>

  <div edsRow>
    <div edsCol class="table-wrapper">
      <ng-container *ngIf="isSiteIntl">
        <table
          class="table"
          #tableResponsive
          [style.display]="(isHandheld$ | async) ? 'none' : ''"
        >
          <ng-container *ngIf="showCanadaDistForEtfMfMmf; else non_canada">
            <ng-container *ngIf="productType === 'ETFs'">
              <thead class="table__thead">
                <tr class="table__tr">
                  <th class="table__th">
                    {{ "pds.MARKET_CURRENCY" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "pds.INCM_DIST_RECORD_DATE" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "products.dist-ex-dist-date" | translate }}
                    <!-- {{ "pds.EX_DIST_DATE" | translate: fundId }} -->
                    <!-- Check PDS "Ex-distribution date" Label -->
                  </th>
                  <th class="table__th">
                    {{ "pds.INCM_DIST_PAYABLE_DATE" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "products.dist-cash-dist-per-unit" | translate }}
                    <!-- {{ "pds.CASH_DIST_PER_UNIT" | translate: fundId }} -->
                  </th>
                  <!-- Check PDS "Cash Distribution Per Unit" Label -->
                  <th class="table__th">
                    {{ "products.dist-rein-dist-per-unit" | translate }}
                    <!-- {{ "pds.REIN_DIST_PER_UNIT" | translate: fundId }} -->
                  </th>
                  <!-- Check PDS "Reinvested Distribution Per Unit" Label -->
                  <th class="table__th">
                    {{ "products.dist-total-dist-per-unit" | translate }}
                    <!-- {{ "pds.TOTAL_DIST_PER_UNIT" | translate: fundId }} -->
                  </th>
                  <!-- Check PDS "Total Distributions per Unit" Label -->
                </tr>
              </thead>

              <tbody class="table__body">
                <tr class="table__tr">
                  <td class="table__td">{{ latestConfig.currencyCode }}</td>
                  <td class="table__td">{{ latestConfig.incomeRecordDate }}</td>
                  <td class="table__td">
                    {{ latestConfig.incomeExDividendDate }}
                  </td>
                  <td class="table__td">
                    {{ latestConfig.incomeDividendDate }}
                  </td>
                  <td class="table__td">
                    {{ latestConfig.incomeDistributionAmount }}
                  </td>
                  <td class="table__td">
                    {{ latestConfig.reInvestmentAmount }}
                  </td>
                  <td class="table__td">
                    {{ latestConfig.totalDistributionAmountMonthly }}
                  </td>
                </tr>
              </tbody>
            </ng-container>

            <ng-container
              *ngIf="
                productType === 'Mutual Funds' ||
                productType === 'Money Market Funds'
              "
            >
              <thead class="table__thead">
                <tr class="table__tr">
                  <th
                    class="table__th"
                    *ngIf="!latestConfig.isSingleShareClass"
                  >
                    {{ "pds.SHARE_CLASS_NAME_STD" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "pds.SHARE_CLASS_CURRENCY" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "pds.INCM_DIST_RECORD_DATE" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "pds.INCM_DIST_PAYABLE_DATE" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "products.dist-dist-price" | translate }}
                  </th>
                  <!-- Check PDS "Distribution Price" Label -->
                  <th class="table__th">
                    {{ "products.dist-inv-income" | translate }}
                  </th>
                  <!-- Check PDS "Investment Income" Label -->
                  <th class="table__th">
                    {{ "products.dist-return-of-cap" | translate }}
                  </th>
                  <!-- Check PDS "Return of Capital" Label -->
                  <th class="table__th">
                    {{ "products.dist-capgains" | translate }}
                  </th>
                  <!-- Check PDS "Capital Gains" Label -->
                  <th class="table__th">
                    {{ "products.dist-total-dist-per-unit" | translate }}
                  </th>
                  <!-- Check PDS "Total Distributions per Unit" Label -->
                </tr>
              </thead>

              <tbody class="table__body">
                <tr class="table__tr">
                  <td
                    class="table__td table__td--share-class"
                    *ngIf="!latestConfig.isSingleShareClass"
                  >
                    {{ latestConfig.shareClassName }}
                  </td>
                  <td class="table__td">{{ latestConfig.currencyCode }}</td>
                  <td class="table__td">{{ latestConfig.incomeRecordDate }}</td>
                  <td class="table__td">
                    {{ latestConfig.incomeDividendDate }}
                  </td>
                  <td class="table__td">
                    {{ latestConfig.reInvestmentAmount }}
                  </td>
                  <td class="table__td">
                    {{ latestConfig.incomeDistributionAmount }}
                  </td>
                  <td class="table__td">
                    {{ latestConfig.returnOfCapitalAmount }}
                  </td>
                  <td class="table__td">
                    {{ latestConfig.capitalGains }}
                  </td>
                  <td class="table__td">
                    {{ latestConfig.totalDistributionAmountMonthly }}
                  </td>
                </tr>
              </tbody>
            </ng-container>
          </ng-container>

          <ng-template #non_canada>
            <thead class="table__thead">
              <tr class="table__tr">
                <th class="table__th" *ngIf="!latestConfig.isSingleShareClass">
                  {{ "pds.SHARE_CLASS_NAME_STD" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "pds.SHARE_CLASS_CURRENCY" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "pds.INCM_DIST_RECORD_DATE" | translate: fundId }}
                </th>
                <th class="table__th" *ngIf="!hideExDistDate">
                  {{ "pds.INCM_DIST_EX_DIV_DATE" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "pds.INCM_DIST_PAYABLE_DATE" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "pds.NAV_VALUE" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "pds.INCM_DIST_AMT" | translate: fundId }}
                </th>
                <th class="table__th" *ngIf="latestConfig.isSgHk">
                  {{ "pds.INCM_DIST_INCOME" | translate: fundId }}
                  <eds-footnote
                    placement="distributable-income-column-header"
                  ></eds-footnote>
                  <button
                    class="print-hidden"
                    *ngIf="
                      tooltips['products.distributable-income-column-header']
                    "
                    edsTooltip
                    edsPadding
                    tooltipTheme="dark"
                    [analyticsName]="'pds.INCM_DIST_INCOME' | translate: fundId"
                    [tooltipContent]="
                      tooltips['products.distributable-income-column-header']
                    "
                    [tooltipAriaLabel]="'pds.INCM_DIST_INCOME' | translate"
                    [tooltipButton]="true"
                  >
                    <eds-icon type="info" size="small"></eds-icon>
                  </button>
                </th>
                <th class="table__th" *ngIf="latestConfig.isSgHk">
                  {{ "pds.INCM_DIV_CAPITAL" | translate: fundId }}
                  <eds-footnote
                    placement="dividend-income-column-header"
                  ></eds-footnote>

                  <button
                    class="print-hidden"
                    *ngIf="tooltips['products.dividend-income-column-header']"
                    edsTooltip
                    [analyticsName]="'pds.INCM_DIV_CAPITAL' | translate: fundId"
                    tooltipTheme="dark"
                    [tooltipContent]="
                      tooltips['products.dividend-income-column-header']
                    "
                    [tooltipAriaLabel]="'pds.INCM_DIV_CAPITAL' | translate"
                    [tooltipButton]="true"
                  >
                    <eds-icon edsPadding type="info" size="small"></eds-icon>
                  </button>
                </th>
              </tr>
            </thead>

            <tbody class="table__body">
              <tr class="table__tr">
                <td
                  class="table__td table__td--share-class"
                  *ngIf="!latestConfig.isSingleShareClass"
                >
                  {{ latestConfig.shareClassName }}
                </td>
                <td class="table__td">{{ latestConfig.currencyCode }}</td>
                <td class="table__td">{{ latestConfig.incomeRecordDate }}</td>
                <td class="table__td" *ngIf="!hideExDistDate">
                  {{ latestConfig.incomeExDividendDate }}
                </td>
                <td class="table__td">{{ latestConfig.incomeDividendDate }}</td>
                <td class="table__td">{{ latestConfig.navValue }}</td>
                <td class="table__td">
                  {{ latestConfig.incomeDistributionAmount }}
                </td>
                <td class="table__td" *ngIf="latestConfig.isSgHk">
                  {{ latestConfig.divDistributionIncome }}
                </td>
                <td class="table__td" *ngIf="latestConfig.isSgHk">
                  {{ latestConfig.dividendCapital }}
                </td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </ng-container>
      <ng-container *ngIf="!isSiteIntl">
        <ng-container *ngIf="latestDistributions.length; else noDataFound_us">
          <table
            class="table"
            #tableResponsive
            [style.display]="(isHandheld$ | async) ? 'none' : ''"
          >
            <ng-container>
              <thead class="table__thead">
                <tr class="table__tr">
                  <th class="table__th">
                    {{ "pds.INCM_DIST_RECORD_DATE" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "pds.INCM_DIST_EX_DIV_DATE" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "pds.REINVESTMENT_DATE" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "pds.INCM_DIST_PAYABLE_DATE" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "pds.REINVESTMENT_AMT" | translate: fundId }}
                  </th>
                  <ng-container *ngIf="productType !== 'Tender Offer Funds'">
                    <th class="table__th">
                      {{ "pds.CAPGAIN_AMT_LONG_TERM" | translate: fundId }}
                    </th>
                    <th class="table__th">
                      {{ "pds.CAPGAIN_AMT_SHRT_TERM" | translate: fundId }}
                    </th>
                  </ng-container>
                  <th class="table__th">
                    {{ "pds.INCOME_AMOUNT" | translate: fundId }}
                  </th>
                  <th class="table__th">
                    {{ "pds.TOTAL_DISTRIBUTION_PER_SHARE" | translate: fundId }}
                  </th>
                </tr>
              </thead>

              <tbody class="table__body">
                <tr
                  class="table__tr"
                  *ngFor="let latestDistribution of latestDistributions"
                >
                  <td
                    class="table__td"
                    *ngIf="latestDistribution.showIncomeOverCapgains"
                  >
                    {{ latestDistribution.incomeRecordDate | ftDashIfEmpty }}
                  </td>
                  <td
                    class="table__td"
                    *ngIf="!latestDistribution.showIncomeOverCapgains"
                  >
                    {{ latestDistribution.capgainsRecordDate | ftDashIfEmpty }}
                  </td>
                  <td
                    class="table__td"
                    *ngIf="latestDistribution.showIncomeOverCapgains"
                  >
                    {{
                      latestDistribution.incomeExDividendDate | ftDashIfEmpty
                    }}
                  </td>
                  <td
                    class="table__td"
                    *ngIf="!latestDistribution.showIncomeOverCapgains"
                  >
                    {{
                      latestDistribution.capgainsExDividendDate | ftDashIfEmpty
                    }}
                  </td>
                  <td
                    class="table__td"
                    *ngIf="latestDistribution.showIncomeOverCapgains"
                  >
                    {{ latestDistribution.reInvestmentDate | ftDashIfEmpty }}
                  </td>
                  <td
                    class="table__td"
                    *ngIf="!latestDistribution.showIncomeOverCapgains"
                  >
                    {{
                      latestDistribution.capgainsReinvestmentDate
                        | ftDashIfEmpty
                    }}
                  </td>
                  <td
                    class="table__td"
                    *ngIf="latestDistribution.showIncomeOverCapgains"
                  >
                    {{ latestDistribution.incomeDividendDate | ftDashIfEmpty }}
                  </td>
                  <td
                    class="table__td"
                    *ngIf="!latestDistribution.showIncomeOverCapgains"
                  >
                    {{ latestDistribution.capgainsPayableDate | ftDashIfEmpty }}
                  </td>
                  <td class="table__td">
                    {{ latestDistribution.reInvestmentAmount | ftDashIfEmpty }}
                  </td>
                  <ng-container *ngIf="productType !== 'Tender Offer Funds'">
                    <td
                      class="table__td"
                      [ngClass]="{
                        'table__td--loss': latestDistribution.estimateFlag
                      }"
                    >
                      <span>
                        {{
                          latestDistribution.longTermCapitalGain | ftDashIfEmpty
                        }}</span
                      >
                      <eds-notifications
                        *ngIf="latestDistribution.estimateFlag"
                        [title]="'products.distribution-estimated' | translate"
                        [notificationType]="notificationType"
                        [hasIcon]="true"
                        [inline]="true"
                        [small]="true"
                      ></eds-notifications>
                    </td>
                    <td
                      class="table__td"
                      [ngClass]="{
                        'table__td--loss': latestDistribution.estimateFlag
                      }"
                    >
                      <span>{{
                        latestDistribution.shortTermCapitalGain | ftDashIfEmpty
                      }}</span>
                      <eds-notifications
                        *ngIf="latestDistribution.estimateFlag"
                        [title]="'products.distribution-estimated' | translate"
                        [notificationType]="notificationType"
                        [hasIcon]="true"
                        [inline]="true"
                        [small]="true"
                      ></eds-notifications>
                    </td>
                  </ng-container>
                  <td class="table__td">
                    {{
                      latestDistribution.incomeDistributionAmount
                        | ftDashIfEmpty
                    }}
                  </td>
                  <td
                    class="table__td"
                    [ngClass]="{
                      'table__td--loss': latestDistribution.estimateFlag
                    }"
                  >
                    <span>{{
                      latestDistribution.totalDistributionAmountMonthly
                        | ftDashIfEmpty
                    }}</span>
                    <eds-notifications
                      *ngIf="latestDistribution.estimateFlag"
                      [title]="'products.distribution-estimated' | translate"
                      [notificationType]="notificationType"
                      [hasIcon]="true"
                      [inline]="true"
                      [small]="true"
                    ></eds-notifications>
                  </td>
                </tr>
              </tbody>
            </ng-container>
          </table>
        </ng-container>
        <ng-template #noDataFound_us>
          {{
            "products.distribution-no-current-year-data-message"
              | translate: fundId
          }}
        </ng-template>
      </ng-container>
    </div>
  </div>
  <div edsRow *ngFor="let card of cards">
    <div edsCol *ngIf="isHandheld$ | async">
      <eds-panel
        edsSpacing="sm"
        [hasBorders]="true"
        [hasBorderRadius]="false"
        [hasPadding]="true"
        [theme]="'white'"
      >
        <eds-info-item *ngFor="let item of card" [info]="item" edsSpacing="sm">
        </eds-info-item>
      </eds-panel>
    </div>
  </div>
</div>
<ng-template let-item #capGainsRow>
  <tr class="dynamic-table__tr">
    <td class="dynamic-table__td">
      {{ item?.capitalGainRecordDate }}
    </td>
    <td class="dynamic-table__td">
      {{ item?.capitalGainExDividendDate }}
    </td>
    <td class="dynamic-table__td">{{ item?.shareClassName }}</td>
    <td class="dynamic-table__td">
      {{ item?.longTermCapitalGainPercent }}
    </td>
    <td class="dynamic-table__td">
      {{ item?.shortTermCapitalGainPercent }}
    </td>
    <td class="dynamic-table__td">
      {{ item?.totalGainNav }}
    </td>
    <td class="dynamic-table__td">
      {{
        item?.actualsAlert
          ? item?.longTermCapitalGainAmount
          : ("products.capgains-actualsposted" | translate)
      }}
    </td>
    <td class="dynamic-table__td">
      {{
        item?.actualsAlert
          ? item?.shortTermCapitalGainAmount
          : ("products.capgains-actualsposted" | translate)
      }}
    </td>
    <td class="dynamic-table__td">
      {{ item?.navValue }}
    </td>
  </tr>
</ng-template>
